export default "__VITE_ASSET__DX3Qgav5__"